"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FoxIcon;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _Context = _interopRequireDefault(require("@foxui/ui-icons/lib/components/Context"));
var _IconFont = _interopRequireDefault(require("@foxui/ui-icons/lib/components/IconFont"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _prepareSvg = require("./prepareSvg");
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var IconProvider = _Context["default"].Provider;
// if (typeof window !== 'undefined') {
//   prepareSvg();
// }
var SourceIcon = (0, _IconFont["default"])({
  // scriptUrl: 'https://at.alicdn.com/t/font_3053452_76179w61k6b.js',
});
/**
 *
 * @param param0
 * @returns
 */
function FoxIcon(_a) {
  var size = _a.size,
    color = _a.color,
    style = _a.style,
    className = _a.className,
    rest = __rest(_a, ["size", "color", "style", "className"]);
  (0, _react.useLayoutEffect)(function () {
    (0, _prepareSvg.prepareSvg)();
  }, []);
  var customStyle = (0, _react.useMemo)(function () {
    var tmp = {};
    if (size !== undefined) {
      tmp.fontSize = size;
    }
    if (color !== undefined) {
      tmp.color = color;
    }
    return tmp;
  }, [size, color]);
  var realStyle = (0, _react.useMemo)(function () {
    if (style) {
      return (0, _extends2["default"])((0, _extends2["default"])({}, customStyle), style);
    }
    return customStyle;
  }, [style, customStyle]);
  return /*#__PURE__*/_react["default"].createElement(IconProvider, {
    value: {
      prefixCls: 'appicon'
    }
  }, /*#__PURE__*/_react["default"].createElement(SourceIcon, (0, _extends2["default"])({
    style: realStyle,
    className: (0, _classnames["default"])('app_icon', className)
  }, rest)));
}